import { render, staticRenderFns } from "./donations.vue?vue&type=template&id=2481393f&scoped=true&"
import script from "./donations.vue?vue&type=script&lang=js&"
export * from "./donations.vue?vue&type=script&lang=js&"
import style0 from "./donations.vue?vue&type=style&index=0&id=2481393f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481393f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsAsideCategories: require('/web/components/objects/AsideCategories.vue').default})
